import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
} from "src/@/components/ui/dialog";
import { Input } from "src/@/components/ui/input";
import { Button } from "src/@/components/ui/button";
import { Separator } from "src/@/components/ui/separator";
import { RadioGroup, RadioGroupItem } from "src/@/components/ui/radio-group";
import { Label } from "src/@/components/ui/label";

const ModalAddMake = ({
  openWebhook,
  nome,
  setNome,
  url,
  setUrl,
  isEdit,
  onEdit,
  onCreate,
  onClose
}) => {



  return (
    <Dialog open={openWebhook} onOpenChange={onClose}>
      <DialogContent className="max-w-md w-full">
        <DialogHeader>
          <DialogTitle>{isEdit ? "Editar" : "Criar"} credencial</DialogTitle>
        </DialogHeader>
        <Separator className="my-4" />
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="nome">Nome</Label>
            <Input
              id="nome"
              autoFocus
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              placeholder="Digite o nome"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="url">URL</Label>
            <Input
              id="url"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              placeholder="Digite a URL"
            />
          </div>

        </div>
        <Separator className="my-4" />
        <DialogFooter className="flex justify-end space-x-4">
          <Button variant="outline" onClick={onClose}>
            Cancelar
          </Button>
          <Button variant="default" onClick={isEdit ? onEdit : onCreate}>
          {isEdit ? "Editar" : "Criar"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ModalAddMake;
